import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { API_IMG_AVATR, Adapter, CommonService, IFormUserProfile, LoginService, RegisterDto, UserProfileRequestDto, UserProfileService } from '../modules/core'
import { catchErrorMsg } from '../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { FormCheckBox, FormDataPicker, FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import moment from 'moment'
import { toAbsoluteUrl } from '_metronic/helpers'
import { ChangePassword } from './setting/ChangePassword'
import { CreateUserPassword } from './setting/CreateUserPassword'
import UseLogin from 'app/modules/core/hooks/users/UseLogin'

type Props = {
    mode: 'user' | 'admin' | 'register'
    userProfileId?: string
    returnUrl: string
}

let initValue: IFormUserProfile = {
    userId: undefined,
    firstName: '',
    lastName: '',
    employeeId: '',
    startWorkingDate: new Date(),
    workingTypeCode: 'FullTime',
    affiliateCode: 'SNH',
    roleCode: 'Employee',
    avatar: '',
    avatarTempUrl: undefined,
    avatarFile: undefined,
    userName: '',
    password: '',
    confirmPassword: '',
    isActive: false,
    email: ''

}

const frmSchema = Yup.object().shape({
    firstName: Yup.string().required('require'),
    lastName: Yup.string().required('require'),
    email: Yup.string().email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
    employeeId: Yup.string().required('require'),
    startWorkingDate: Yup.date().required('require'),
    workingTypeCode: Yup.string().required('require'),
    affiliateCode: Yup.string().required('require'),
})

const frmSchemaRegister = Yup.object().shape({
    firstName: Yup.string().required('require'),
    lastName: Yup.string().required('require'),
    email: Yup.string().email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
    employeeId: Yup.string().required('require'),
    startWorkingDate: Yup.date().required('require'),
    workingTypeCode: Yup.string().required('require'),
    affiliateCode: Yup.string().required('require'),
    userName: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('require'),
    password: Yup.string()
        .min(6, 'Minimum 6 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
    confirmPassword: Yup.string()
        .min(6, 'Minimum 6 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
})

export const ProfileComponent: FC<Props> = (props) => {
    const useLogin = UseLogin()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<IFormUserProfile>(initValue)
    const [hasUser, setHasUser] = useState<{
        userId?: string,
        mode: 'new' | 'edit'
    }>({
        userId: undefined,
        mode: 'new'
    })

    const [userName,setUserName] = useState<string>('')

    const navigate = useNavigate()
    useEffect(() => {
        const init = () => {
            if (props.userProfileId && props.userProfileId !== 'new') {
                UserProfileService.GetById(props.userProfileId).then((result) => {
                    const res = result.data.result
                    if (res) {
                        const frmDto = Adapter.FormUserProfile(res);
                        setData(frmDto)
                        setHasUser({
                            userId: res.userId,
                            mode: res.userId ? 'edit' : 'new'
                        })
                    }

                })
            }
        }
        init()
    }, [props.userProfileId])


    useEffect(()=>{
        if(hasUser.userId!=null){
            UserProfileService.GetUserName(hasUser.userId).then(({data})=> setUserName(data.result))
        }

    },[hasUser.userId])

    const onSubmit = async (values: IFormUserProfile) => {
        setLoading(true)

        const updatedData = Adapter.mapUserProfile(values)
        if (values.avatarFile) {
            try {
                const response = await CommonService.uploadFile('avatar', values.avatarFile)
                updatedData.avatar = response.data.result.fileName
            } catch (ex) {
                toast.error(catchErrorMsg(ex))
                setLoading(false)
                return
            }
        }

        if (props.userProfileId && props.userProfileId !== 'new') {
            Update(props.userProfileId, updatedData)
        } else if (props.userProfileId && props.userProfileId === 'new') {
            Save(updatedData)
        } else if (props.mode === 'register') {
            const registerDto = Adapter.mapUserRegiseter(values)
            Register(registerDto)
        }

    }
    const Update = (id: string, updatedData: UserProfileRequestDto) => {
        UserProfileService.Update(id, updatedData).then(() => {
            toast.success('Update Success.')
            navigate(props.returnUrl)
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }
    const Save = (updatedData: UserProfileRequestDto) => {
        UserProfileService.Create(updatedData).then(() => {
            toast.success('Create Success.')
            navigate(props.returnUrl)
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }
    const Register = (updatedData: RegisterDto) => {
        LoginService.Register(updatedData).then(() => {
            toast.success('Create Success.')
            navigate(props.returnUrl)
        }).catch((res) => {

            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }

    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold '
        const inputCls = props.inputCls ?? 'col-lg-8'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}
            </div>
        )
    }

    return (
        <>
            <PageTitle
                breadcrumbs={[
                    {
                        title: 'User Profile',
                        path: props.returnUrl,
                        isSeparator: false,
                        isActive: false,
                    },
                ]}
            >
                User Profile
            </PageTitle>
            <div className='card mb-5 mb-xl-10'>

                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={props.mode === 'register' ? frmSchemaRegister : frmSchema}
                    onSubmit={onSubmit}
                // validate={(v) => console.log(v)}
                >
                    {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                        <Form>
                            <>
                                {/* begin::Scroll */}
                                <div className='card-body p-9'>
                                    {props.mode !== 'register' && <CellStyle lable='Avatar'>
                                        <div
                                            className='image-input image-input-outline'
                                            data-kt-image-input='true'
                                            style={{
                                                backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`,
                                            }}
                                        >
                                            <div
                                                className='image-input-wrapper w-125px h-125px'
                                                style={{
                                                    backgroundImage: `url(${toAbsoluteUrl(`${API_IMG_AVATR}/` + values.avatar)})`,
                                                }}
                                            ></div>
                                        </div>
                                        <div>
                                            <input
                                                id='avatar'
                                                name='avatar'
                                                type='file'
                                                className='form-control'
                                                onChange={(event: any) => {
                                                    const objectUrl = URL.createObjectURL(event.currentTarget.files[0])
                                                    setFieldValue('avatarTempUrl', objectUrl)
                                                    setFieldValue('avatarFile', event.currentTarget.files[0])
                                                }}
                                            />
                                            <span className='text-danger'>
                                                size 100 kbyte (".jpg", ".jpeg", ".png", ".bmp", ".gif")
                                            </span>
                                        </div>
                                    </CellStyle>}
                                    <CellStyle lable='ชื่อ'>
                                        <Field
                                            autoComplete='off'
                                            name='firstName'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.firstName && touched.firstName ? ' is-invalid' : '')
                                            }

                                        />
                                        <ErrorMessage name={`firstName`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='นามสกุล'>
                                        <Field
                                            autoComplete='off'
                                            name='lastName'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.lastName && touched.lastName ? ' is-invalid' : '')
                                            }

                                        />
                                        <ErrorMessage name={`lastName`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='Email'>
                                        <Field
                                            autoComplete='off'
                                            name='email'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.email && touched.email ? ' is-invalid' : '')
                                            }

                                        />
                                        <ErrorMessage name={`email`} component='div' className='text-danger' />
                                    </CellStyle>

                                    <CellStyle lable='รหัสพนักงาน'>
                                        <Field
                                            name='employeeId'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.employeeId && touched.employeeId ? ' is-invalid' : '')
                                            }
                                        />
                                        <ErrorMessage name={`employeeId`} component='div' className='text-danger' />
                                    </CellStyle>

                                    <CellStyle lable='วันเริ่มงาน'>
                                        <Field
                                            as='text'
                                            name='startWorkingDate'
                                            className={
                                                'form-control form-control-solid' +
                                                (errors.startWorkingDate && touched.startWorkingDate ? ' is-invalid' : '')
                                            }
                                            value={moment(values.startWorkingDate).format('DD/MM/YYYY')}
                                            onDateChange={(value: Date, e: any) => {
                                                setFieldValue('startWorkingDate', value)
                                            }}

                                            maxDate={new Date()}
                                            component={FormDataPicker}
                                        />
                                        {/* <ReactCalendar/> */}
                                        <ErrorMessage name={`recordDate`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='ประเภทพนักงาน'  >
                                        <div className='d-flex justify-content-between'>
                                            <Field
                                                label={'Full time'}
                                                name={`workingTypeCode`}
                                                gName={`workingTypeCode`}
                                                gValue={'FullTime'}
                                                component={FormRadio}

                                            />
                                            <Field
                                                label={'Part Time'}
                                                name={`workingTypeCode`}
                                                gName={`workingTypeCode`}
                                                gValue={'PartTime'}
                                                component={FormRadio}
                                            />
                                        </div>
                                    </CellStyle>
                                    <CellStyle lable='สังกัด'>
                                        <div className='d-flex justify-content-between'>
                                            <Field
                                                label={'SNH'}
                                                name={`affiliateCode`}
                                                gName={`affiliateCode`}
                                                gValue={'SNH'}
                                                component={FormRadio}
                                            />
                                            <Field
                                                label={'SVH'}
                                                name={`affiliateCode`}
                                                gName={`affiliateCode`}
                                                gValue={'SVH'}
                                                component={FormRadio}
                                            />
                                            <Field
                                                label={'Other'}
                                                name={`affiliateCode`}
                                                gName={`affiliateCode`}
                                                gValue={'Other'}
                                                component={FormRadio}
                                            />
                                        </div>
                                    </CellStyle>

                                    {props.mode === 'register' && <>
                                        <CellStyle lable='UserName'>
                                            <Field
                                                autoComplete='off'
                                                name='userName'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.userName && touched.userName ? ' is-invalid' : '')
                                                }

                                            />
                                            <ErrorMessage name={`userName`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='Password'>
                                            <Field
                                                autoComplete='off'
                                                name='password'
                                                type='password'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.password && touched.password ? ' is-invalid' : '')
                                                }

                                            />
                                            <ErrorMessage name={`password`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='Confirm Password'>
                                            <Field
                                                autoComplete='off'
                                                name='confirmPassword'
                                                type='password'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')
                                                }

                                            />
                                            <ErrorMessage name={`confirmPassword`} component='div' className='text-danger' />
                                        </CellStyle>

                                    </>}


                                    {/* <CellStyle lable='Role'>
                                        {userLogin.roleCode === 'Admin' ? <div className='d-flex justify-content-between'>
                                            <Field
                                                label={RoleCodeEnum[RoleCodeEnum.Employee]}
                                                name={`roleCode`}
                                                gName={`roleCode`}
                                                gValue={RoleCodeEnum[RoleCodeEnum.Employee]}
                                                component={FormRadio}
                                            />
                                            <Field
                                                label={RoleCodeEnum[RoleCodeEnum.Admin]}
                                                name={`roleCode`}
                                                gName={`roleCode`}
                                                gValue={RoleCodeEnum[RoleCodeEnum.Admin]}
                                                component={FormRadio}
                                            />
                                        </div> : <>
                                            <label>{values.roleCode}</label>
                                        </>}
                                    </CellStyle> */}

                                    {useLogin && useLogin.roleCode === 'Admin' && <CellStyle lable='IsActive'>
                                        <Field

                                            name='isActive'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.isActive && touched.isActive ? ' is-invalid' : '')
                                            }
                                            component={FormCheckBox}
                                        />
                                        <ErrorMessage name={`isActive`} component='div' className='text-danger' />
                                    </CellStyle>}
                                </div>
                                {/* end::Scroll */}

                                <div className='card-footer d-flex py-6 px-9'>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                        {!loading && props.mode === 'register' ? 'Register' : 'Save Changes'}
                                        {loading && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>

                                    <button className='btn btn-light' onClick={() => navigate(props.returnUrl)}> Back</button>
                                </div>
                            </>
                        </Form>
                    )}
                </Formik>
            </div>

            {props.mode !== 'register' && props.userProfileId !== 'new' && <div className='card mb-5 mb-xl-10'>
                <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_signin_method'
                >
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>Sign-in Method</h3>
                    </div>
                </div>

                <div id='kt_account_signin_method' className='collapse show'>
                    <div className='card-body border-top p-9'>
                       
                        {props.userProfileId && hasUser.mode === 'edit' ? <>
                         <div className='col-lg-4'>
                            <div className='fv-row mb-0'>
                                <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                                    UserName : 
                                </label>
                                 {userName}
                            </div>
                        </div>
                        
                        <ChangePassword userId={hasUser.userId ?? ''} />
                        </> :
                            <CreateUserPassword userProfileId={props.userProfileId ?? ''}
                                onSaved={() => setHasUser({
                                    ...hasUser,
                                    mode: 'edit'
                                })} />}

                    </div>
                </div>
            </div>}

        </>
    )
}

